import classes from "./Medal.module.scss";

const MedalDeactive = () => (
<svg
  className={classes.MedalDeactive}
  viewBox="0 0 21.912277 29.440477"
  version="1.1"
  width="25px"
  height="30px"
>
  <defs>
    {/* Reusable shapes */}
    <rect id="rectMain1" width={3.2228823} height={11.572436} rx={1.6114411} ry={2.1056647} />
    <rect id="rectMain2" width={4.6446376} height={8.6062403} ry={2.3223188} />
    <rect id="rectMain3" width={4.6446381} height={8.6062403} ry={2.322319} />
    <circle id="circleMain1" r={5.2466178} />
    <path id="pathMain1" />
    <path id="pathMain2" />
    <path id="pathMain3" />
  </defs>

  <g transform="translate(-90.352981,-89.279535)">
    <g transform="matrix(1.7735944,0,0,1.7735944,-531.39778,-786.46559)">
      <use href="#rectMain1" x={-497.04166} y={-362.61417} fill="#c0c0c0" stroke="none" transform="matrix(0,-1,-1,0,0,0)" />
      <use href="#rectMain2" x={55.224731} y={603.77692} fill="#d4d4d4" stroke="none" transform="rotate(-30)" />
      <use href="#rectMain3" x={-562.68292} y={247.06499} fill="#d7d7d7" stroke="none" transform="matrix(-0.8660254,-0.5,-0.5,0.8660254,0,0)" />

      <g transform="matrix(0.02203394,0,0,0.02203394,362.52975,498.07082)" fill="#cfcfcf" stroke="#d2d2d2">
        <path
          d="m -138.07051,259.40597 v -70.64 a 15.6,15.6 0 1 0 -8.92,0 v 70.18 a 108.21,108.21 0 0 0 -37.54,-32.21 c -29.52,-15.63 -61.67,-17.31 -74.12,-17.31 h -8.9 c -12.46,0 -44.6,1.68 -74.14,17.3 a 108.26,108.26 0 0 0 -37,31.44 v -69.4 a 15.6,15.6 0 1 0 -8.91,0 v 70.64 0 a 30.08,30.08 0 0 0 -30.08,30.08 v 20.06 a 22.28,22.28 0 0 0 17.28,21.68 21.89,21.89 0 0 0 5,0.58 h 3.9 v -0.2 c 0,-56.61 29.34,-84 54,-97 27.76,-14.7 58.18,-16.28 70,-16.28 h 0.79 c 2.44,0 4.9,0 7.27,0 h 0.84 c 11.79,0 42.2,1.58 70,16.28 24.61,13 54,40.41 54,97 v 0.2 h 4.45 a 22.11,22.11 0 0 0 15.76,-6.53 22.21,22.21 0 0 0 6.53,-15.75 v -20.04 a 30.08,30.08 0 0 0 -30.08,-30.08 z m -251.76,-85.58 a 6.69,6.69 0 1 1 6.69,6.68 6.7,6.7 0 0 1 -6.69,-6.68 z m 240.59,0 a 6.69,6.69 0 1 1 6.69,6.68 6.7,6.7 0 0 1 -6.67,-6.68 z"
        />
        <path
          d="m -384.83051,331.62597 c 0,100.85 95.43,106.6 117.3,106.6 h 8.85 c 21.86,0 117.26,-5.75 117.26,-106.6 0,-102 -97.65,-106.73 -118,-106.6 h -7.41 c -20.31,-0.13 -118,4.56 -118,106.6 z"
        />
        <path
          d="m -152.56051,331.62597 q 0,27.75 -10.42,47.73 -11.12,-21.37 -34,-33.52 c -24.25,-12.83 -51.18,-14.21 -61.63,-14.21 h -8.9 c -10.47,0 -37.38,1.38 -61.64,14.21 q -22.89,12.09 -34,33.52 -10.4,-19.94 -10.42,-47.73 c 0,-38.32 15,-65.66 44.47,-81.26 24.26,-12.82 51.17,-14.2 61.64,-14.2 h 8.9 c 10.45,0 37.38,1.38 61.63,14.2 29.42,15.6 44.37,42.94 44.37,81.26 z"
          strokeOpacity={1}
        />
        <rect x={-368.71045} y={274.17603} width={211.75} height={109.04} rx={54.52} fill="#cfcfcf" stroke="#d2d2d2" />
        <path
          d="m -262.83051,354.87597 a 28.57,28.57 0 0 1 -9.69,-1.67 4.0454543,4.0454543 0 1 1 2.72,-7.62 21.06,21.06 0 0 0 13.93,0 4.047138,4.047138 0 1 1 2.73,7.62 28.57,28.57 0 0 1 -9.69,1.67 z"
        />
        <circle cx={-310.23047} cy={323.97595} r={14.02} />
        <circle cx={-215.43054} cy={323.97595} r={14.02} />
      </g>

      <circle
        cx={258.73434}
        cy={-561.27826}
        r={4.4190979}
        fill="none"
        stroke="#f2f2f2"
        transform="rotate(120)"
      />
    </g>
  </g>
</svg>);
export { MedalDeactive };
